module.exports = __webpack_public_path__ + "img/unlock.220cc9c1.svg";